import styled from "styled-components";

export const PageWrapper = styled.div`
   width: 100%;
   margin-top: 60px;
   //min-height: calc(100vh - 60px);
`;